import { ComponentIds, HierarchyUtils, PartPair, ReplaceAssemblyPartUtils } from '@inter-ikea-core/core';
import { SystemBase2 } from '@inter-ikea-core/core-toolbox';
import { ProductInfoComponent, ProductType } from '@inter-ikea-storageone/range';
const NORMAL_HINGES = ['00214505', '30214504'];
const CORNER_HINGES = ['corner_hinge-6', 'corner_hinge-8'];
export class CornerHingeSystem extends SystemBase2 {
    constructor(coreServices) {
        super(ComponentIds.MOVED_TO_CANDIDATE_SNAP_POSITION_COMPONENT_ID, ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this.coreServices = coreServices;
        this.id = 'CornerHingeSystem';
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.doingChangesOnComponent = [];
    }
    onAddComponent(entity, newComponent) {
        this.fix(entity, newComponent);
    }
    onUpdateComponent(entity, _oldComponent, newComponent) {
        this.fix(entity, newComponent);
    }
    onRemoveComponent(_entity, _oldComponent) {
        // Do nothing
    }
    onAddComponent2(entity, _newComponent) {
        this.fix(entity, null);
    }
    onUpdateComponent2(entity, _oldComponent, _newComponent) {
        this.fix(entity, null);
    }
    onRemoveComponent2(_entity, _oldComponent) {
        // Do nothing
    }
    fix(entity, newComponent) {
        if (entity.hasComponent(ComponentIds.DOOR_COMPONENT_ID)) {
            const parent = newComponent?.snap?.host || HierarchyUtils.parent(entity);
            if (parent) {
                const isCornerFrame = HierarchyUtils.findInUpwardsHierarchy(parent, e => e.getComponent(ProductInfoComponent.id)?.productType ===
                    ProductType.PAX_CORNER_SOLUTION_ASM);
                if (isCornerFrame) {
                    this.replaceHinges(entity, NORMAL_HINGES, CORNER_HINGES);
                }
                else {
                    this.replaceHinges(entity, CORNER_HINGES, NORMAL_HINGES);
                }
            }
        }
    }
    replaceHinges(door, sourceHinges, targetHinges) {
        const hingePartKeys = door
            .getComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)
            ?.parts.filter(part => part.partKey.includes('hinge'))
            .map(part => part.partKey);
        if (!hingePartKeys || hingePartKeys?.length === 0) {
            return;
        }
        const currentHingeRef = HierarchyUtils.descendants(door)
            .find(e => e.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey ===
            hingePartKeys[0])
            ?.getComponent(ComponentIds.PRODUCT_COMPONENT_ID)?.productRef;
        const index = sourceHinges.indexOf(currentHingeRef || '');
        const newHingeRef = index > -1 && targetHinges[index];
        if (newHingeRef) {
            const replacePartPairs = hingePartKeys.map(key => new PartPair(key, newHingeRef));
            ReplaceAssemblyPartUtils.replaceProductParts(door, replacePartPairs, this.coreServices);
        }
    }
}
//# sourceMappingURL=CornerHingeSystem.js.map